import React from 'react'
import { Switch, Route } from 'react-router-dom'
import { Home } from '../views/home/Home'

import Error404 from '../views/404'

//加盟管理
//意向加盟
import { JoinIntention } from '../views/join/intention/view'
import { JoinIntentionDetails } from '../views/join/intention/view/details'
//合作加盟
import { CooperateIntention } from '@/views/join/cooperate/view'
import { CooperateIntentionDetails } from '@/views/join/cooperate/view/details'

//数据字典
import { BaseDict } from '../views/base/dict/view'

//供应商结算
import { SettleConfig } from '../views/base/settleConfig/view'
import { Unsettle } from '../views/settle/unsettle/view/index'
import { Settled } from '../views/settle/settled/view/index'
//供应商结算-工单详情
import { MaintenanceDetails } from '../views/settle/order/detail'

// 消息提醒
import { Messagewarnlist } from '../views/messagewarn/view'

//字段设置
import { FieldSet } from '../views/base/fieldSet/view'

function AppRoute() {
    return (
        <Switch>
            <Route exact={true} path={'/'} key="1" component={Home} />
            {/* 加盟管理 */}
            <Route exact={true} path={'/join/intention'} key="2-1" component={JoinIntention} />
            <Route exact={true} path={'/join/intention/add'} key="2-1-1" component={JoinIntentionDetails} />
            <Route exact={true} path={'/join/intention/edit'} key="2-1-2" component={JoinIntentionDetails} />
            <Route exact={true} path={'/join/cooperate'} key="2-2" component={CooperateIntention} />
            <Route exact={true} path={'/join/cooperate/look'} key="2-2-1" component={CooperateIntentionDetails} />

            {/* 基础数据 */}
            <Route exact={true} path={'/base/dict'} key="3-1" component={BaseDict} />
            <Route exact={true} path={'/base/settleConfig'} key="3-2" component={SettleConfig} />
            <Route exact={true} path={'/base/fieldSet'} key="3-3" component={FieldSet} />

            <Route exact={true} path={'/settle/unsettle'} key="4-1" component={Unsettle} />
            <Route exact={true} path={'/settle/settled'} key="4-2" component={Settled} />
            <Route exact={true} path={'/settle/order'} key="4-3" component={MaintenanceDetails} />

            {/* 消息列表  */}
            <Route exact={true} path={'/messagewarn'} key="10-1" component={Messagewarnlist} />

            <Route exact={true} path={'/*'} key="404" component={Error404} />

        </Switch>
    )
}

export default AppRoute
